import script from "./emoji.vue?vue&type=script&setup=true&lang=js"
export * from "./emoji.vue?vue&type=script&setup=true&lang=js"

import "./emoji.vue?vue&type=style&index=0&id=7de00975&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de00975"]])

export default __exports__